import { create } from "zustand";
import { api } from "../services/api";

const useAiStore = create((set, get) => ({
  enabled: false,
  loaded: false,
  loading: false,
  fetchStatus: async () => {
    // O api.js aborta requisições concorrentes para a mesma URL, então evita chamadas paralelas.
    if (get().loaded || get().loading) return;

    set({ loading: true });

    try {
      const { data } = await api.get("/ai/status");
      set({ enabled: Boolean(data?.data?.enabled), loaded: true, loading: false });
    } catch (err) {
      set({ enabled: false, loaded: true, loading: false });
    }
  }
}));

export default useAiStore;
